import ArtistVideoPlayer from "../../utils/ArtistVideoPlayer";
import React from "react";
import { useGalleryVideosForPreview } from "@/api/hooks/useGalleryVideosForPreview";
import { useArtistProfilePic } from "@/api/hooks/useArtistDisplayName";

const VideoPlaceholder = ({ className }: { className?: string }) => (
  <div
    className={`bg-[#2C2C2E] flex items-center justify-center rounded-lg ${className}`}
    aria-hidden
  >
    <div className="w-12 h-12 rounded-full border-2 border-[#8E8E93] border-dashed opacity-50" />
  </div>
);

const ArtistEliteVideos = () => {
  const { slots } = useGalleryVideosForPreview("elite");
  const profilePic = useArtistProfilePic();
  const firstSlot = slots[0];
  const thumbSlots = slots;

  return (
    <div className="mt-40 bg-purple-800/10 px-7 rounded-xl w-screen">
      <div className=" py-7">
        <div className="flex items-start justify-center max-lg:flex-col gap-10">
          <div className="relative w-full max-w-6xl border border-zinc-700 mb-2 aspect-video shadow-2xl shadow-purple-900 pointer-events-none overflow-hidden">
            {firstSlot?.type === "video" ? (
              <ArtistVideoPlayer
                source={firstSlot.source}
                profile_pic={profilePic ?? ""}
              />
            ) : (
              <VideoPlaceholder className="w-full h-full" />
            )}
          </div>

          <div className="max-w-[340px] w-full h-[56.25vw] max-h-[68vh] max-md:h-full max-lg:max-w-full overflow-y-auto scrollbar-hide space-y-2 max-md:mx-auto pointer-events-none">
            {thumbSlots.map((slot) =>
              slot.type === "video" ? (
                <div key={slot.id} className="bg-zinc-800/70 rounded-lg">
                  <ArtistVideoPlayer
                    source={slot.source}
                    isThumbnail
                    isElite
                    profile_pic={profilePic ?? ""}
                  />
                </div>
              ) : (
                <div
                  key={`ph-${slot.index}`}
                  className="bg-zinc-800/70 rounded-lg min-h-[120px] flex items-center justify-center"
                >
                  <VideoPlaceholder className="w-full min-h-[120px]" />
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArtistEliteVideos;